import comp from "./Sidebar";

export default comp;
